import { Buttons, Image, Scroller, Slider } from '@cian/slider';
import { IconActionClose16, IconActionFullscreen16 } from '@cian/ui-kit-design-tokens/icons';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import { useState } from 'react';

import { NoPhoto } from 'shared/components/common/NoPhoto';

import style from './style.css';

export interface IOfferGalleryProps {
  photos: string[];
  alt: string;
}

const Photos = ({ photos, alt, onFullscreenClick }: IOfferGalleryProps & { onFullscreenClick?(): void }) => (
  <Slider loop behavior="smooth">
    <div className={style['slides']} data-name="OfferGallerySlides">
      <Scroller>
        {photos.map((url, index) => (
          <Image key={`${url}-${index}`} src={url} alt={alt} objectFit="contain" />
        ))}
      </Scroller>
      {photos.length > 1 && <Buttons size="M" />}
      {onFullscreenClick && (
        <button type="button" className={style['button']} title="Открыть на весь экран" onClick={onFullscreenClick}>
          <IconActionFullscreen16 color="icon-inverted-default" />
        </button>
      )}
    </div>
  </Slider>
);

/** Фото объявления в превью — fotorama монолита высотой 360 без миниатюр */
export const OfferGallery = ({ photos, alt }: IOfferGalleryProps) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  if (!photos.length) {
    return (
      <div className={style['empty']} data-name="OfferGalleryEmpty">
        <NoPhoto variant="offer" />
      </div>
    );
  }

  return (
    <div className={style['container']}>
      <Photos photos={photos} alt={alt} onFullscreenClick={() => setIsFullscreen(true)} />
      <ModalFullscreen open={isFullscreen} escape theme="black" onClose={() => setIsFullscreen(false)}>
        <div className={style['fullscreen']} data-name="OfferGalleryFullscreen">
          <button type="button" className={style['button']} title="Закрыть" onClick={() => setIsFullscreen(false)}>
            <IconActionClose16 color="icon-inverted-default" />
          </button>
          <Photos photos={photos} alt={alt} />
        </div>
      </ModalFullscreen>
    </div>
  );
};
